module.exports = __webpack_public_path__ + "static/media/spray-bottle.2b9091ff.svg";